import { Box, Typography } from '@mui/material'
import ProgramPageHero from '../components/programs/ProgramPageHero'
import ProgramWhySection from '../components/programs/ProgramWhySection'
import PartnerFocusAreasSection from '../components/partner/PartnerFocusAreasSection'
import { sharedStarIcon } from '../assets/index'
import {
  partnerHero,
  togetherSection,
  whyPartner,
  whoCanPartner,
  benefitsPartnership,
} from '../data/partnerContent'
import {
  programSectionWrapperSx,
  programInnerSx,
  programSectionGap,
} from '../components/programs/programLayout'
import { mobileSectionPy } from '../theme/mobileLayout'

const partnerBodyFontSize = { xs: 16, sm: 22, md: 26, lg: 26 }
const partnerListItemFontSize = { xs: 20, sm: 24, md: 26, lg: 26 }

function PartnerTogetherSection() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: { xs: 3, md: 4, lg: 6 },
        width: '100%',
      }}
    >
      <Typography
        component="h2"
        sx={{
          fontSize: { xs: 22, md: 22 },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          flexShrink: 0,
          maxWidth: { md: 280, lg: 308 },
          whiteSpace: 'pre-line',
        }}
      >
        {togetherSection.title}
      </Typography>

      <Typography
        sx={{
          fontSize: { xs: 20, sm: 24, md: 26, lg: 26 },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          width: { xs: '100%', md: 700, lg: 1000 },
          maxWidth: '100%',
        }}
      >
        {togetherSection.text}
      </Typography>
    </Box>
  )
}

export default function PartnerPage() {
  return (
    <Box>
      <Box
        sx={{
          ...programSectionWrapperSx,
          pt: { ...mobileSectionPy, md: '120px', lg: '260px' },
          pb: { xs: 6, md: 8 },
        }}
      >
        <ProgramPageHero
          title={partnerHero.title}
          subtitle={partnerHero.subtitle}
          cta={partnerHero.cta}
          ctaLink={partnerHero.ctaLink}
          subtitleSx={{ fontSize: partnerBodyFontSize }}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: programSectionGap,
          pb: { xs: 8, md: 12, lg: '150px' },
        }}
      >
        <Box sx={programSectionWrapperSx}>
          <Box
            sx={{
              ...programInnerSx,
              display: 'flex',
              flexDirection: 'column',
              gap: programSectionGap,
            }}
          >
            <PartnerTogetherSection />

            <ProgramWhySection
              title={whyPartner.title}
              items={whyPartner.items}
              starSrc={sharedStarIcon}
              titleMaxWidth={whyPartner.titleMaxWidth}
              itemFontSize={partnerListItemFontSize}
            />

            <ProgramWhySection
              title={whoCanPartner.title}
              items={whoCanPartner.items}
              starSrc={sharedStarIcon}
              titleMaxWidth={whoCanPartner.titleMaxWidth}
              itemFontSize={partnerListItemFontSize}
            />
          </Box>
        </Box>

        <PartnerFocusAreasSection />

        <Box sx={programSectionWrapperSx}>
          <Box sx={programInnerSx}>
            <ProgramWhySection
              title={benefitsPartnership.title}
              items={benefitsPartnership.items}
              starSrc={sharedStarIcon}
              titleMaxWidth={benefitsPartnership.titleMaxWidth}
              itemFontSize={partnerListItemFontSize}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
